import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import { Button } from '@finect/tabular-core/Button';
import { TextButton } from '@finect/tabular-core/TextButton';
import { ShoppingCart } from '@finect/tabular-icons/shoppingCart';
import { getProductAction } from '@finect/front-resources/Products';
import { StyledBuyButton } from './partials';
var VARIANTS = {
  textButton: {
    component: TextButton,
    withLabel: false,
    withIcon: true
  },
  button: {
    component: Button,
    withLabel: true,
    withIcon: true,
    width: 'auto',
    size: 'small'
  },
  cta: {
    component: Button,
    height: '42px',
    withLabel: true,
    withIcon: false,
    width: '100%',
    size: 'medium'
  }
};
export var BuyButton = function BuyButton(_ref) {
  var onAction = _ref.onAction,
    product = _ref.product,
    variant = _ref.variant;
  var entity = product.entity;
  var buyButtonProps = _defineProperty({
    title: entity.transactionable ? 'Me interesa' : 'No disponible',
    disabled: !entity.transactionable,
    onClick: entity.transactionable ? onAction : function () {}
  }, entity.transactionable ? 'secondary' : 'terciary', true);
  var _VARIANTS$variant = VARIANTS[variant],
    component = _VARIANTS$variant.component,
    withLabel = _VARIANTS$variant.withLabel,
    withIcon = _VARIANTS$variant.withIcon,
    _VARIANTS$variant$wid = _VARIANTS$variant.width,
    width = _VARIANTS$variant$wid === void 0 ? 'auto' : _VARIANTS$variant$wid,
    _VARIANTS$variant$siz = _VARIANTS$variant.size,
    size = _VARIANTS$variant$siz === void 0 ? 'small' : _VARIANTS$variant$siz,
    _VARIANTS$variant$hei = _VARIANTS$variant.height,
    height = _VARIANTS$variant$hei === void 0 ? null : _VARIANTS$variant$hei;
  var action = getProductAction(product);
  var icon = action.icon;
  return React.createElement(StyledBuyButton, _extends({
    as: component,
    width: width,
    height: height,
    variant: size,
    onClick: onAction
  }, buyButtonProps), React.createElement("span", null, withIcon && icon ? React.createElement(ShoppingCart, {
    size: "18",
    strokeWidth: "2.5"
  }) : null, withLabel ? action.action : null));
};